import { createStore, compose } from 'redux'
import { enableBatching } from 'redux-batched-actions'
import thunk from 'redux-thunk'
import api from '../../middleware/api'
import moduleMiddleware from '../../middleware/module'
import filterModuleMiddleware from '../../middleware/filterModule'
import errorMiddleware from '../../middleware/error'
import loginRedirect from '../../middleware/loginRedirect'
import notificationsMiddleware from '../../middleware/notifications'
import family from '../../server/models/family'

/*
import valodial from '../../server/models/valodial'
import authentication from '../../server/models/authentication'
import commitment from '../../server/models/commitment'
import uapl from '../../server/models/uapl.client'
import rte from '../../server/models/rte'
 */
import bpshop from '../../server/models/bpshop'

import suiviEngagement from "../../server/models/suiviEngagement";
import technical from '../../server/models/technical.common'
import fncs from '../../server/models/fncs'
import cnda from '../../server/models/cnda'
import edfin from '../../server/models/edf-in'
import slp from '../../server/models/slp.client'
import keenpointActions from '../../server/models/keenpointActions'
import audit from '../../server/models/audit'


import * as alerts from '../../server/models/crossModels/alerts'
import * as documents from '../../server/models/crossModels/documents'
import * as messaging from '../../server/models/crossModels/messaging'
import * as texting from '../../server/models/crossModels/texting'
import * as survey from '../../server/models/crossModels/survey'
import * as tickets from '../../server/models/crossModels/tickets'
import * as documentDb from '../../server/models/crossModels/documentDatabase'
import * as saveLog from '../../server/models/crossModels/saveLog'
import * as mediaBase from '../../server/models/crossModels/mediaBase'
import * as auditLog from '../../server/models/crossModels/auditLog'
import * as emailsQueue from '../../server/models/crossModels/emailsQueue'


import ClientEnhancer from '../../utils/ClientEnhancer'
import _ from "lodash";

const modelsList = [
    technical, family, cnda, fncs, edfin, slp, keenpointActions, suiviEngagement, bpshop, audit
    //, valodial, authentication, uapl, commitment, rte
]

const elementsCrossModels = [alerts, documents, messaging, texting, survey, tickets, documentDb, saveLog, mediaBase, auditLog, emailsQueue]

const models = modelsList.map(model => {
    return model.id === 'T'
        ? model
        : {
            ...model,
            entities: _.concat(
                model.entities,
                elementsCrossModels.flatMap(element => _.cloneDeep(element.entities(model.id)))
            ),
            modules:
                _.concat(
                    model.modules,
                    elementsCrossModels.flatMap(element => _.cloneDeep(element.modules(model.id)))
                )

        }
})

const enhanceStoreWithClientEnhancer = createStore => (...args) => {
    const store = createStore(...args)

    const clientEnhancer = new ClientEnhancer(models)

    return {
        ...store,
        clientEnhancer
    }
}

function applyMiddlewareCustom(middlewares, {setTheme}) {
    return createStore => (...args) => {
        const store = createStore(...args)
        let dispatch = () => {
            throw new Error(
                `Dispatching while constructing your middleware is not allowed. ` +
                `Other middleware would not be applied to this dispatch.`
            )
        }
        let chain

        const middlewareAPI = {
            getState: store.getState,
            dispatch: (...args) => dispatch(...args),
            clientEnhancer: store.clientEnhancer,
            setTheme
        }
        chain = middlewares.map(middleware => middleware(middlewareAPI))
        dispatch = compose(...chain)(store.dispatch)

        return {
            ...store,
            dispatch
        }
    }
}

export default function(name, reducer, params) {

    // if (process.env.NODE_ENV !== "production") {
    //     middlewares.push(createLogger())
    // }

    const composeEnhancers =
        process.env.NODE_ENV !== 'production' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                  name,
                  actionsBlacklist: ['REDUX_STORAGE_SAVE']
              })
            : compose

    return createStore(
        enableBatching(reducer),
        composeEnhancers(
            applyMiddlewareCustom([thunk, api, moduleMiddleware, filterModuleMiddleware, loginRedirect, errorMiddleware, notificationsMiddleware], params),
            enhanceStoreWithClientEnhancer
        )
    )
}
